<div class="flex flex-col bg-[var(--colorGrey)] mt-8 mb-8 p-4 rounded text-[var(--color-text-strong)]">
    <div class="flex flex-col">
        <p class="font-bold">{{ title() }}</p>
        <p class="text-[rgb(var(--ui-5))] mt-2 mb-2 text-sm">{{ subtitle() }}</p>
        <div class="flex flex-row justify-between text-[rgb(var(--ui-5))] mb-2 text-sm">
            <p>
                {{ 'seasons.season-details.setting-cards.social-criteria-card.criteria-label' | translate }}
            </p>
            <p class="pr-5">
                {{ 'seasons.season-details.setting-cards.social-criteria-card.weight-label' | translate }}
            </p>
        </div>
        @for (socialCriteria of socialCriterias(); track socialCriteria) {
            <div>
                <div class="flex justify-between">
                    <p>
                        {{
                            'seasons.season-details.setting-cards.social-criteria-card.' +
                                (socialCriteria.joinedEntityName ? socialCriteria.joinedEntityName + '-' : '') +
                                socialCriteria.property | translate
                        }}
                    </p>
                    <p class="pr-8">{{ socialCriteria.weight }}</p>
                </div>
                <div class="mt-2 mb-2 h-px bg-[rgb(var(--ui-6))]" aria-hidden="true"></div>
            </div>
        }
    </div>
</div>
